import scrollLock from './scrollLock';

const getCursorY = e => {
  // eslint-disable-next-line no-restricted-globals
  const backgroundPos = window.Event
    ? e.pageY
    : // eslint-disable-next-line no-restricted-globals
      event.clientY +
      (document.documentElement.scrollTop
        ? document.documentElement.scrollTop
        : document.body.scrollTop);
  const position = `calc(-100% + ${backgroundPos}px  + 17px)`;
  document.getElementById(
    'c-navigation__background',
  ).style.transform = `translateY(${position})`;
};

const menu = () => {
  const navigationToggle = document.querySelector('[data-toggle="menu"]');
  const navigation = document.querySelector('.c-navigation');

  if (navigationToggle) {
    navigationToggle.addEventListener('click', e => {
      e.preventDefault();

      if (navigationToggle.classList.contains('active')) {
        navigationToggle.classList.remove('active');
        navigation.classList.remove('active');
        scrollLock.unlock('.c-header');
      } else {
        navigationToggle.classList.add('active');
        navigation.classList.add('active');
        scrollLock.lock('.c-header');

        navigation.onmousemove = getCursorY;
        navigation.onmouseleave = () => {
          navigation.classList.add('c-navigation--leave');
          document.getElementById('c-navigation__background').style = '';
        };
        navigation.onmouseenter = () => {
          navigation.classList.remove('c-navigation--leave');
        };
      }
    });
  }

  // # add close function inside of navigation

  const navigationClose = document.querySelector('[data-toggle="closemenu"]');
  if (navigationClose) {
    navigationClose.addEventListener('click', e => {
      e.preventDefault();

      if (navigationToggle.classList.contains('active')) {
        navigationToggle.classList.remove('active');
        navigation.classList.remove('active');
        scrollLock.unlock('.c-header');
      }
    });
  }

  // # close navigation on click outside of navigation

  const navElem = document.querySelector('.c-navigation');
  document.addEventListener('click', event => {
    if (
      event.target.closest('.c-navigation') ||
      event.target.closest('[data-toggle="menu"]')
    )
      return;

    navigation.classList.remove('active');
    navElem.classList.remove('active');
    scrollLock.unlock('.c-header');
  });
};

export default menu;



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/menu.js